module.exports = __webpack_public_path__ + "static/media/1-ristorante-comp.c3e469d5.jpeg";